export default "__VITE_ASSET__BuNjhR1n__"